// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".threeSixthModal-wrapper-A-s {\n}\n\n.threeSixthModal-wrapper-A-s iframe .threeSixthModal-fullscreen-cRV {\n  display: none;\n}\n.threeSixthModal-closeButton-4qi {\n}\n\n.threeSixthModal-closeButton-4qi svg {\n  width: 44px;\n  height: 44px;\n}\n\n.threeSixthModal-closeButton-4qi svg path {\n  stroke: var(--venia-global-color-dovetail);\n  stroke-width: 1px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "threeSixthModal-wrapper-A-s bg-white h-full w-full",
	"fullscreen": "threeSixthModal-fullscreen-cRV",
	"closeButton": "threeSixthModal-closeButton-4qi fixed top-12 left-14 z-50 cursor-pointer"
};
export default ___CSS_LOADER_EXPORT___;
